<template lang="html">
  <div>
    <nav-list>
      <nav-item group="admin">
        <nav-title path="/admin-list/all">
          <span>
            <i class="ico--admin"></i>
            관리자 계정 등록 및 관리
          </span>
        </nav-title>
      </nav-item>

      <!-- <nav-item group="permission">
        <nav-title path="/permission-list/all">
          <span>
            <i class="ico--domain"></i>
            관리자 등급별 권한 설정
          </span>
        </nav-title>
      </nav-item> -->

      <nav-item group="whitelist">
        <nav-title path="/whitelist/all">
          <span>
            <i class="ico--ip"></i>
            화이트 IP 관리
          </span>
        </nav-title>
      </nav-item>

      <!-- <nav-item group="admin logs">
        <nav-title path="/admin-logs/users/all">
          <span>
            <i class="ico--bethistory"></i>
            관리자 로그
          </span>
        </nav-title>
      </nav-item> -->

      <nav-item group="super admin logs">
        <nav-title path="/super-admin-logs/all">
          <span>
            <i class="ico--bethistory"></i>
            슈퍼 관리자 로그
          </span>
        </nav-title>
      </nav-item>

      <!-- <nav-item group="admin session setting">
        <nav-title @click.native="sessionSetting.show = true">
          <span>
            <i class="ico--settings"></i>
            관리자 세션 설정
          </span>
        </nav-title>
      </nav-item> -->

      <!-- <nav-item group="import excel">
        <nav-title path="/import/agent">
          <span>
            import excel
          </span>
        </nav-title>
      </nav-item> -->

      <!-- nav-item group="admins">
        <nav-title path="/admins">
          <span>
            <i class="ico--codes"></i>
            adminss
          </span>
        </nav-title>
      </nav-item -->
      <nav-item group="admin logs">
        <nav-title path="/admin-logs/users/all">
          <span>
            <i class="ico--bethistory"></i>
            일반 관리자 로그
          </span>
        </nav-title>
      </nav-item>
    </nav-list>

    <modal
      class="modal--edit-setting"
      title="관리자 세션 변경"
      v-if="sessionSetting.show"
      :activate="sessionSetting.show"
      @activate="sessionSetting.show = $event"
    >
      <template slot="body">
        <div class="form-con">
          <div class="form-items admin-setting">
            <div class="form-lbl">
              세션타임
            </div>

            <div class="input-wrap">
              <input
                v-model="sessionSetting.data.setting_json.duration"
                type="number"
              />
            </div>
          </div>

          <div class="form-items admin-setting">
            <div class="form-lbl">
              타입
            </div>

            <div class="input-wrap">
              <select2 v-model="sessionSetting.data.setting_json.type">
                <option2
                  :value="sessionSetting.data.setting_json.type"
                  selected
                  hidden
                  v-text="sessionSetting.data.setting_json.type"
                />

                <option2
                  v-for="(i, key) in ['s', 'm', 'h', 'd']"
                  :key="key"
                  :selected="i === sessionSetting.data.setting_json.type"
                  :value="i"
                  v-text="i"
                />
              </select2>
            </div>
          </div>
        </div>
      </template>

      <template slot="footer">
        <button
          @click="saveModify()"
          class="btn--modify -withlabel -right"
        >
          <i class="ico--save"></i>
          <span>수정</span>
        </button>
      </template>
    </modal>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

//= components
import Modal from '@/components/base/Modal'
import '@/components/layout/navigation/Nav'

//= mixins
import { ready } from '@/assets/js/mixins/base/Ready'
import { swal } from '@/assets/js/mixins/base/Swal'

export default {
  name: 'navigation',

  provide () {
    const handleNav = this.handleNav
    return { handleNav }
  },

  mixins: [
    ready,
    swal
  ],

  components: {
    Modal
  },

  data () {
    return {
      handleNav: {
        group: null,
        subnav: false
      },

      navItems: [],
      subnavItems: [],
      duplicatePaths: [],

      sessionSetting: {
        show: false,
        data: {}
      }
    }
  },

  computed: {
    ...mapState('settings', ['adminSessionSetting']),

    permissionKeys () {
      let permissions
      if (window.localStorage.permission) {
        permissions = JSON.parse(window.localStorage.permission)
        return Object.keys(permissions)
      }
    }
  },

  watch: {
    async '$route' ($router) {
      this.getnavItems()
      this.getnavTitle()
      this.getsubnavItems()
      this.getduplicatePaths()
      this.setDefaultPaths()
    }
  },

  created () {
    this.getDefaultSetting()
  },

  mounted () {
    this.getnavItems()
    this.getnavTitle()
    this.getsubnavItems()
    this.getduplicatePaths()
    this.setDefaultPaths()
  },

  methods: {
    ...mapActions('settings', {
      getAdminSessionSetting: 'getAdminSessionSetting',
      updateAdminSessionSetting: 'updateAdminSessionSetting'
    }),

    getnavItems () {
      let navItems = this.$children[0].$children
      let items = []

      for (var navItem = 0; navItem < navItems.length; navItem++) {
        items.push((navItems[navItem]))
      }

      this.navItems = items
    },

    getnavTitle () {
      for (var i = 0; i < this.navItems.length; i++) {
        var navTitle = this.navItems[i].$children[0]
        if (navTitle.path) {
          if (this.navItems[i].$children.length === 1) {
            let titlePath = navTitle.path.split('/').filter(function (e) { return e })
            navTitle.defaultPath = '/' + titlePath[0]
          }
        }
      }
    },

    getsubnavItems () {
      let subnavItems = []

      for (var i = 0; i < this.navItems.length; i++) {
        var navTitle = this.navItems[i].$children[0]
        var subNav = this.navItems[i].$children[1]

        if (this.navItems[i].$children.length > 1) {
          this.navItems[i].withSubNav = true

          var subnavChildren = subNav.$children

          for (var x = 0; x < subnavChildren.length; x++) {
            navTitle.subnavPath = subnavChildren[0].path
            subnavItems.push((subnavChildren[x]))
          }
        }
      }

      this.subnavItems = subnavItems
    },

    saveModify () {
      const success = async () => {
        const params = {
          ...this.sessionSetting.data
        }

        const reponse = await this.updateAdminSessionSetting(params)

        if (reponse.status === 200) {
          this.sessionSetting.show = false
          await this.getDefaultSetting()
          this.$alert('success', '세션 설정을 변경 하였습니다.', {}, {}, '완료')
        }
      }

      this.$alert('prompt', '정말 수정 하시겠습니까?', {}, { success }, '세션수정')
    },

    async getDefaultSetting () {
      await this.getAdminSessionSetting()
      this.sessionSetting.data = { ...this.adminSessionSetting }
    },

    getduplicatePaths () {
      // var subItemPath // transfers/all => [transfers, all]
      // var firstRouteArr = [] // transfers/all => [transfers]
      // var secondaryRouteArr = [] // transfers/all => [all]
      //
      // for (var i = 0; i < this.subnavItems.length; i++) {
      //   subItemPath = this.subnavItems[i].path.split('/').filter(function (e) { return e })
      //
      //   if (subItemPath.length) {
      //     firstRouteArr.push((subItemPath[0]))
      //
      //     if (subItemPath.length === 2) {
      //       secondaryRouteArr.push((subItemPath[1]))
      //     }
      //   } // if
      //
      //   let groupDuplicates = _.groupBy(firstRouteArr)
      //
      //   var duplicateName = []
      //   var duplicateNumber = []
      //
      //   for (var key in groupDuplicates) {
      //     if (groupDuplicates[key].length > 1) {
      //       duplicateName.push(key)
      //       duplicateNumber.push(groupDuplicates[key].length)
      //     }
      //   }
      // }
      //
      // this.duplicatePaths = duplicateName
    },

    setDefaultPaths () {
      // for (var i = 0; i < this.subnavItems.length; i++) {
      //   let subItemPath = this.subnavItems[i].path.split('/').filter(function (e) { return e })
      //
      //   for (var x = 0; x < subItemPath.length; x++) {
      //     this.subnavItems[i].defaultPath = '/' + subItemPath[0]
      //
      //     if (this.duplicatePaths.indexOf(subItemPath[0]) > -1) {
      //       if (subItemPath[1]) {
      //         this.subnavItems[i].defaultPath = '/' + subItemPath[0] + '/' + subItemPath[1]
      //         this.subnavItems[i].withDuplicates = true
      //       }
      //     }
      //   }
      // }
    }, // setDefaultPaths

    checkPermission (data) {
      let idx
      if (this.permissionKeys) {
        idx = this.permissionKeys.indexOf(data)
      }
      return idx > -1 ? 1 : ''
    }
  }
}
</script>
